<section class="app_attachUploadFile__container">
  <section class="app_attachUploadFile__fileList_container" *ngIf="displayFileList">
    <div class="app_attachUploadFile__fileList_titels">
      <span>Archivo</span>
      <span>Acciones</span>
    </div>
    <div class="app_attachUploadFile__fileList_items" *ngFor="let file of fileList">
      <span>
        <img style="display: block;" id="{{ file.name }}" />
        {{ file.name }}
      </span>
      <span>


        <!-- BOTON VER/DESACARGAR ARCHIVO ADJUNTO-->
        <a [href]="file.archivoBase64" class="active" download="{{ file.name }}" (click)="downloadFile(file)"
          *ngIf="file.archivoBase64 != null">
          <span class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <defs>
                <style>
                  .a85ee722-d9d1-41ec-9bfa-269845bbf416 {
                    fill: none;
                  }

                  .eye {
                    fill: #555;
                  }
                </style>
              </defs>
              <g id="e0eaa876-258b-433f-92fc-d27d550864ca" data-name="Kit_4">
                <g id="ac9a3c6f-22d5-49a2-a37b-6cc848e35787" data-name="Visibility_icon">
                  <rect class="a85ee722-d9d1-41ec-9bfa-269845bbf416" x="0.01" width="24" height="24" />
                  <g id="e260d318-40d0-4350-9572-e400822f5040" data-name="Contorneado">
                    <path class="ec837a78-20e9-44c3-9359-2bc4c4a64a85"
                      d="M12,18.88A10.68,10.68,0,0,1,3.08,14c-.11-.17-.38-.66-.62-1.12a2,2,0,0,1,0-1.88c.24-.46.51-.95.63-1.12a10.6,10.6,0,0,1,17.84,0c.12.17.39.67.63,1.13a2,2,0,0,1,0,1.87c-.24.47-.51,1-.63,1.14A10.67,10.67,0,0,1,12,18.88ZM4.18,11.94h0A8.84,8.84,0,0,0,12,16.88a8.84,8.84,0,0,0,7.83-4.94h0A8.84,8.84,0,0,0,12,7a8.84,8.84,0,0,0-7.83,4.94Z" />
                    <path class="ec837a78-20e9-44c3-9359-2bc4c4a64a85"
                      d="M12,16.14A4.14,4.14,0,1,1,16.15,12,4.14,4.14,0,0,1,12,16.14Zm0-6.27A2.14,2.14,0,1,0,14.15,12,2.14,2.14,0,0,0,12,9.87Z" />
                  </g>
                </g>
              </g>
            </svg>
          </span>
          <span>
            Ver archivo
          </span>
        </a>

        <a class="disable" *ngIf="file.archivoBase64 == null">
          <span class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <defs>
                <style>
                  .a85ee722-d9d1-41ec-9bfa-269845bbf416 {
                    fill: none;
                  }

                  .eye {
                    fill: #555;
                  }
                </style>
              </defs>
              <g id="e0eaa876-258b-433f-92fc-d27d550864ca" data-name="Kit_4">
                <g id="ac9a3c6f-22d5-49a2-a37b-6cc848e35787" data-name="Visibility_icon">
                  <rect class="a85ee722-d9d1-41ec-9bfa-269845bbf416" x="0.01" width="24" height="24" />
                  <g id="e260d318-40d0-4350-9572-e400822f5040" data-name="Contorneado">
                    <path class="ec837a78-20e9-44c3-9359-2bc4c4a64a85"
                      d="M12,18.88A10.68,10.68,0,0,1,3.08,14c-.11-.17-.38-.66-.62-1.12a2,2,0,0,1,0-1.88c.24-.46.51-.95.63-1.12a10.6,10.6,0,0,1,17.84,0c.12.17.39.67.63,1.13a2,2,0,0,1,0,1.87c-.24.47-.51,1-.63,1.14A10.67,10.67,0,0,1,12,18.88ZM4.18,11.94h0A8.84,8.84,0,0,0,12,16.88a8.84,8.84,0,0,0,7.83-4.94h0A8.84,8.84,0,0,0,12,7a8.84,8.84,0,0,0-7.83,4.94Z" />
                    <path class="ec837a78-20e9-44c3-9359-2bc4c4a64a85"
                      d="M12,16.14A4.14,4.14,0,1,1,16.15,12,4.14,4.14,0,0,1,12,16.14Zm0-6.27A2.14,2.14,0,1,0,14.15,12,2.14,2.14,0,0,0,12,9.87Z" />
                  </g>
                </g>
              </g>
            </svg>
          </span>
          <span>
            Ver archivo
          </span>
        </a>

        <!-- BOTON ELIMINAR ARCHIVO ADJUNTO-->
        <a class="danger" (click)="removeFile(file)" *ngIf="viewMode !== 'ver'">
          <span class="icon danger">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <defs>
                <style>
                  .ee241f2b-8860-42b8-8abb-0107cf5d005d {
                    fill: none;
                  }

                  .dange {
                    fill: #555;
                  }
                </style>
              </defs>
              <g id="bed4e532-51c9-47e6-82e4-a7400fcdd30f" data-name="Kit_3">
                <g id="e687df95-e02a-479c-954a-67dbd2184732" data-name="Grid_delete_icon_V3">
                  <rect class="ee241f2b-8860-42b8-8abb-0107cf5d005d" width="24" height="24" />
                  <g id="ef581423-faf0-4a8d-b9aa-a2de6d25cd61" data-name="Trazado">
                    <path class="b95d3524-2685-43a8-bac5-56ee48d5279b"
                      d="M21,5.88H16V4a2,2,0,0,0-2-2H10A2,2,0,0,0,8,4V5.88H3a1,1,0,1,0,0,2h.89L5.3,19.37a3,3,0,0,0,3,2.63h7.43a3,3,0,0,0,3-2.63L20.11,7.88H21a1,1,0,0,0,0-2ZM10,4H14V5.88H10ZM16.7,19.13a1,1,0,0,1-1,.87H8.28a1,1,0,0,1-1-.87L5.9,7.88H18.09Z" />
                    <path class="b95d3524-2685-43a8-bac5-56ee48d5279b"
                      d="M10,16a1,1,0,0,1-1-1V11.66a1,1,0,0,1,2,0V15A1,1,0,0,1,10,16Z" />
                    <path class="b95d3524-2685-43a8-bac5-56ee48d5279b"
                      d="M14.05,16a1,1,0,0,1-1-1V11.66a1,1,0,0,1,2,0V15A1,1,0,0,1,14.05,16Z" />
                  </g>
                </g>
              </g>
            </svg>
          </span>
          <span>Eliminar</span>
        </a>

        <a class="disable" *ngIf="viewMode === 'ver'">
          <span class="icon danger">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <defs>
                <style>
                  .ee241f2b-8860-42b8-8abb-0107cf5d005d {
                    fill: none;
                  }

                  .dange {
                    fill: #555;
                  }
                </style>
              </defs>
              <g id="bed4e532-51c9-47e6-82e4-a7400fcdd30f" data-name="Kit_3">
                <g id="e687df95-e02a-479c-954a-67dbd2184732" data-name="Grid_delete_icon_V3">
                  <rect class="ee241f2b-8860-42b8-8abb-0107cf5d005d" width="24" height="24" />
                  <g id="ef581423-faf0-4a8d-b9aa-a2de6d25cd61" data-name="Trazado">
                    <path class="b95d3524-2685-43a8-bac5-56ee48d5279b"
                      d="M21,5.88H16V4a2,2,0,0,0-2-2H10A2,2,0,0,0,8,4V5.88H3a1,1,0,1,0,0,2h.89L5.3,19.37a3,3,0,0,0,3,2.63h7.43a3,3,0,0,0,3-2.63L20.11,7.88H21a1,1,0,0,0,0-2ZM10,4H14V5.88H10ZM16.7,19.13a1,1,0,0,1-1,.87H8.28a1,1,0,0,1-1-.87L5.9,7.88H18.09Z" />
                    <path class="b95d3524-2685-43a8-bac5-56ee48d5279b"
                      d="M10,16a1,1,0,0,1-1-1V11.66a1,1,0,0,1,2,0V15A1,1,0,0,1,10,16Z" />
                    <path class="b95d3524-2685-43a8-bac5-56ee48d5279b"
                      d="M14.05,16a1,1,0,0,1-1-1V11.66a1,1,0,0,1,2,0V15A1,1,0,0,1,14.05,16Z" />
                  </g>
                </g>
              </g>
            </svg>
          </span>
          <span>Eliminar</span>
        </a>



      </span>
    </div>
    <p-divider></p-divider>
  </section>
  <label class="app_attachUploadFile__button" *ngIf="!disableLoader">
    <span> <span class="p-button-icon p-button-icon-left pi pi-plus"></span> Adjuntar archivo</span>
    <span #form>
      <input id="attachedFile" type="file" #inputFile (change)="onUpload($event)" />
    </span>
  </label>
  <label class="app_attachUploadFile__button app_attachUploadFile__button--disabled" *ngIf="disableLoader">
    <span> <span class="p-button-icon p-button-icon-left pi pi-plus"></span> Adjuntar archivo</span>
  </label>
</section>
